






































import { Component, Prop, Vue } from 'vue-property-decorator'
import { MenuTreeNode } from '@/services/menuData'

@Component
export default class MenuTree extends Vue {
  @Prop() data: MenuTreeNode[]
  isDev: boolean

  mounted () {
    this.isDev = process.env === 'development'
  }

  defaultProps = {
    children: 'children',
    label: 'label'
  }
}
